import { Box, Display, FlexDirection } from '@gousto-internal/citrus-react'
import type { DashboardExperienceRootSectionItem } from '@library/api-dashboard-experience'
import React from 'react'

import { DashboardSectionItem } from './DashboardSectionItem'
import {
  type DashboardExperienceActionClickHandler,
  isRenderableDashboardExperienceItem,
} from './dashboardExperienceItemRenderer'

type DashboardSectionProps = {
  items: DashboardExperienceRootSectionItem[]
  label: string
  onActionClick: DashboardExperienceActionClickHandler
}

export function DashboardSection({ items, label, onActionClick }: DashboardSectionProps) {
  const renderableItems = items.filter(isRenderableDashboardExperienceItem)

  if (!renderableItems.length) {
    return null
  }

  return (
    <section aria-label={label} style={{ width: '100%' }}>
      <Box display={Display.Flex} flexDirection={FlexDirection.Column} gap={[4, 3]} width="100%">
        {renderableItems.map((item, index) => (
          <DashboardSectionItem
            item={item}
            key={`${item.type}-${index}`}
            onActionClick={onActionClick}
          />
        ))}
      </Box>
    </section>
  )
}
